import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import OrdersBox from '../../components/admin/OrdersBox'
import CurriculumLayout from '../../components/layout/CurriculumLayout'

const Orders = () => {
  return (
    <div>
      <AdminLayout>
        <AdminContentLayout>
          <CurriculumLayout title={'Orders'}>
            <OrdersBox />
          </CurriculumLayout>
        </AdminContentLayout>
      </AdminLayout>
    </div>
  )
}

export default Orders
